<template>
  <div class="setion">
    <div class="title">代注册一尘卖家会员<br />需要提供的资料如下(缺一不可)</div>
    <div class="h">用户名：</div>
    <div class="h">
      密码：最少9位数字，字母加数字的组合
    </div>
    <div class="h">忘记密码的提示问题</div>
    <div class="h">邮箱:（推荐QQ邮箱）</div>
    <div class="h">姓名：</div>
    <div class="h">邮政编码：</div>
    <div class="h">通讯地址：</div>
    <div class="h">身份证地址：</div>
    <div class="h">常用电话：</div>
    <div class="h">身份证号:</div>
    <div class="h">常用银行卡号：(开户行+卡号)</div>
    <div class="h">身份证正反面照片：</div>
    <div class="h">汇款凭证照片：</div>
    <div class="h">常用电话的缴费单照片：</div>
    <div class="h">营业执照照片(可选)</div>
    <div class="h">备注说明：</div>

    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" />

    <div class="h">一尘卖家会员年费220元;</div>
    <div class="h">需要先汇款到一尘网账户：</div>
    <div class="h">户 名：杭州量尘科技有限公司</div>
    <div class="h">开户行：中国工商银行杭州仁和支行</div>
    <div class="h">帐 号：12021 91309 10002 1822</div>
    <div class="h">汇款时，在留言栏写：注册会员费220元</div>

    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
      特别说明
    </van-divider>

    <div class="h">只要提交的认证资料没问题，提交过后72小时之内即可通过认证成为一尘卖家会员。</div>
    <div class="h">
      因一尘注册会员流程繁琐,注意事项很多，故代注册会员为有偿服务，一次收取100元费用。需要注册一尘会员的藏友,准备好上述资料，点击
      <span @click="addUser" style="font-size:20px;color:#1989fa">添加客服</span>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
  data() {
    return {};
  },
  methods: {
    addUser() {
      ImagePreview(['https://ui.smartrecorder.xyz/image/wxCard.jpg']);
    },
  },
};
</script>
<style scoped>
.setion {
  padding: 0 20px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.setion .title {
  color: #1a1e25;
  font-size: 20px;
  font-weight: 600;
  padding-top: 20px;
  margin-bottom: 14px;
  text-align: center;
}
.setion .h {
  font-size: 13px;
  color: #1a1e25;
  font-weight: 600;
  margin-bottom: 11px;
}
.setion .s {
  color: #969696;
  margin-bottom: 10px;
  font-size: 10px;
}
</style>
